export default __webpack_public_path__ + "static/media/bg-cny-banner.b2218a56.png";